export default __webpack_public_path__ + "static/media/map-secondary-marker.icon.c52f8694.svg";